const DashboardProblemsPage = () => {
  return (
    <div>DashboardProblemsPage</div>
  );
};

export default DashboardProblemsPage;
